import ChannelsV2Filters from './ChannelsV2Filters'
export default ChannelsV2Filters
